import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigPolicyComponent } from './config-policy.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomHandler } from '@dm/ang';
import { CoreModule } from '@dm/core';

@NgModule({
    declarations: [ConfigPolicyComponent],
    exports: [ConfigPolicyComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [DomHandler],
})
export class ConfigPolicyModule { }
